export default __webpack_public_path__ + "static/media/game.82c94dbd.png";